import { Component } from '@angular/core';

@Component({
    selector: 'betalabs-analytics',
    templateUrl: './betalabs-analytics.component.html'
})
export class BetalabsAnalyticsComponent {
    public content = 'var alreadyInitialized = window.initializeGAEcommercesBetalabs || false;\n' +
        '\n' +
        'if (!alreadyInitialized) {\n' +
        '   window.initializeGAEcommercesBetalabs = true;\n' +
        '   window.dataLayer = window.dataLayer || [];\n' +
        '   function gtag(){dataLayer.push(arguments);}\n' +
        '   gtag(\'js\', new Date());\n' +
        '   gtag(\'config\', \'G-29TE1B8ZRK\');' +
        '   alreadyInitialized = true;\n' +
        '}';
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/betalabs-analytics/betalabs-analytics.component.ts